module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4gIaFgAk9pTPoQAAAGtJREFUOMvVk7ENgDAMBD9RxqBJxSpkEJbxr8keT5EIUERB5CLiG58Lvyy/HCTBowin3AaJ5OYxCHIeIQIAyUKyDPIOAJAkM1slQVX4wm1G81PoDcIgI7WaSeYpMaYrjlvHg5euf93g5890AusrXGcB7nsLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/ruler.png
// module id = 1076
// module chunks = 0